import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

const LOGO = "https://customer-assets.emergentagent.com/job_salon-studio-pro-2/artifacts/7kyv63p4_LOGO%20LAKA%20CLUB%20BEAUTY.webp";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Bienvenida");
      nav("/");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Error al iniciar sesión";
      toast.error(typeof msg === "string" ? msg : "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row" style={{ backgroundColor: "var(--laka-ivory)" }}>
      {/* Left panel — brand */}
      <div
        className="lg:w-1/2 flex flex-col justify-between p-10 lg:p-16 relative"
        style={{ backgroundColor: "#1A1A1A", color: "#FBF6F2" }}
      >
        <Link
          to="/catalogo"
          data-testid="back-to-catalog"
          className="inline-flex items-center gap-2 text-xs tracking-widest uppercase hover:text-[#D6B36A] transition-colors self-start"
          style={{ color: "#B8B0A6" }}
        >
          <ArrowLeft size={14} strokeWidth={1.25} /> Ver tratamientos
        </Link>

        <div>
          <div className="inline-block px-6 py-6 rounded-md" style={{ backgroundColor: "#FBF6F2" }}>
            <img src={LOGO} alt="LAKA Club Beauty" className="h-24 w-auto object-contain" />
          </div>
          <div className="mt-8 font-display text-4xl lg:text-5xl leading-none">
            Business Studio
          </div>
          <div className="mt-3 laka-eyebrow" style={{ color: "#D6B36A" }}>
            Panel operativo interno
          </div>
          <p className="mt-6 text-sm max-w-md" style={{ color: "#B8B0A6" }}>
            El espacio de gestión de LAKA Club Beauty. Membresías, clientes, agenda y seguimiento comercial en una sola herramienta.
          </p>
        </div>

        <div className="text-[10px] tracking-widest uppercase" style={{ color: "#4a453e" }}>
          © LAKA Club Beauty · Estética avanzada &amp; bienestar
        </div>
      </div>

      {/* Right panel — form */}
      <div className="lg:w-1/2 flex items-center justify-center p-8 lg:p-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="laka-eyebrow">Acceso restringido</div>
          <h1 className="font-display text-4xl lg:text-5xl mt-2 leading-none">Iniciar sesión</h1>
          <p className="text-sm mt-3" style={{ color: "var(--laka-text)" }}>
            Introduce tus credenciales para acceder al panel de gestión.
          </p>

          <div className="mt-8 space-y-4">
            <div>
              <Label htmlFor="username" className="text-xs tracking-widest uppercase" style={{ color: "var(--laka-text)" }}>Usuario</Label>
              <Input
                id="username"
                data-testid="login-username"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                className="mt-1 h-12"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs tracking-widest uppercase" style={{ color: "var(--laka-text)" }}>Contraseña</Label>
              <Input
                id="password"
                data-testid="login-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••••"
                className="mt-1 h-12"
                required
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="laka-btn-primary w-full h-12 mt-8 rounded-md"
          >
            <Lock size={14} strokeWidth={1.5} className="mr-2" />
            {loading ? "Verificando…" : "Entrar al panel"}
          </Button>

          <div className="mt-8 pt-6 border-t laka-hairline text-xs text-center" style={{ color: "var(--laka-text)" }}>
            ¿No tienes acceso? Consulta con la dirección del centro.
          </div>
        </form>
      </div>
    </div>
  );
}
